const CANVAS_TENANT_CONTEXT_URL_PREFIX = '/gateway/api/canvas-tenant-context/site';

export const getCanvasServerUrl = (siteId: string) => {
  if (!siteId) {
    throw new Error('siteId is not defined');
  }

  return `${CANVAS_TENANT_CONTEXT_URL_PREFIX}/${siteId}`;
};
